import { render } from "./Popper.vue?vue&type=template&id=2d7c4e1a&scoped=true"
import script from "./Popper.vue?vue&type=script&lang=js"
export * from "./Popper.vue?vue&type=script&lang=js"

import "./Popper.vue?vue&type=style&index=0&id=2d7c4e1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7c4e1a"]])

export default __exports__